export const DEFAULT_REGULATION_COUNTRY_CODE = 'FRA';

const COUNTRY_ALPHA2_BY_ALPHA3: Record<string, string> = {
  AUT: 'AT',
  BEL: 'BE',
  CHE: 'CH',
  CZE: 'CZ',
  DEU: 'DE',
  ESP: 'ES',
  FRA: 'FR',
  GBR: 'GB',
  ITA: 'IT',
  LUX: 'LU',
  NLD: 'NL',
  POL: 'PL',
};

export function normalizeRegulationCountryCodes(countryCodes: string[]) {
  const normalizedCodes = countryCodes
    .map((countryCode) => countryCode.trim().toUpperCase())
    .filter((countryCode) => /^[A-Z]{3}$/.test(countryCode));

  return [...new Set(normalizedCodes)];
}

export function resolveAvailableRegulationCountryCodes(
  selectedCountryCodes: string[],
  availableCountryCodes: string[],
) {
  const selectedCodes = normalizeRegulationCountryCodes(selectedCountryCodes);
  const availableCodes = normalizeRegulationCountryCodes(availableCountryCodes);
  if (!availableCodes.length) {
    return selectedCodes.length ? selectedCodes : [DEFAULT_REGULATION_COUNTRY_CODE];
  }

  const selectedAvailableCodes = selectedCodes.filter((countryCode) =>
    availableCodes.includes(countryCode),
  );
  if (selectedAvailableCodes.length) {
    return selectedAvailableCodes;
  }

  return [availableCodes.includes(DEFAULT_REGULATION_COUNTRY_CODE)
    ? DEFAULT_REGULATION_COUNTRY_CODE
    : availableCodes[0]];
}

export function regulationCountryName(countryCode: string, locale: string) {
  const normalizedCode = countryCode.trim().toUpperCase();
  const alpha2Code = COUNTRY_ALPHA2_BY_ALPHA3[normalizedCode];
  if (!alpha2Code || typeof Intl.DisplayNames === 'undefined') {
    return normalizedCode;
  }

  return new Intl.DisplayNames([resolveDisplayLocale(locale)], { type: 'region' }).of(alpha2Code) || normalizedCode;
}

export function regulationCountryFlag(countryCode: string) {
  const alpha2Code = COUNTRY_ALPHA2_BY_ALPHA3[countryCode.trim().toUpperCase()];
  if (!alpha2Code) {
    return '🌐';
  }

  return alpha2Code
    .split('')
    .map((letter) => String.fromCodePoint(127397 + letter.charCodeAt(0)))
    .join('');
}

function resolveDisplayLocale(locale: string) {
  return locale.trim().toLowerCase().startsWith('fr') ? 'fr-FR' : 'en-US';
}
